import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody,
} from 'reactstrap';
import {
  FALLBACK_ICON,
} from '../../utils';

function SeeContract(props) {
  const {
    isOpen, onClose, offerData,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const hideModal = () => {
    toggle();
    onClose();
  };
  const createMarkup = () => ({ __html: offerData && offerData.createContract });

  return (
    <Modal isOpen={modal} className="modal-contract">
      <ModalBody>
        <div className="create-contract">
          <div className="create-contract-head">
            <div className="create-contract-head-container">
              <h1>Contract details</h1>
              <div className="create-contract-head-btn-group">
                <span onClick={hideModal} className="icon icon-cross m-0 p-0" />
              </div>
            </div>
          </div>
          <div className="create-contract-content">
            <div className="create-contract-content-container">
              <div className="create-contract-content-container-data">
                <div className="campaign-head-brand">
                  <div className="campaign-head-image">
                    <img
                      src={offerData && offerData.clientLogo
                        ? offerData.clientLogo
                        : FALLBACK_ICON}
                      alt="Offer"
                      className="image-cover"
                    />
                  </div>
                  <div className="campaign-head-detail">
                    <p>{offerData && offerData.clientName}</p>
                    <h2>{offerData && offerData.title}</h2>
                  </div>
                </div>
                <div dangerouslySetInnerHTML={createMarkup()} />
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

SeeContract.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  offerData: PropTypes.object.isRequired,
};

export default SeeContract;
